import React, { useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";
import "./RegisterForm.css";

function RegisterForm() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    userType: "",
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    address: ""
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setMessage("Passwords do not match!");
      return;
    }

    try {
      if (formData.userType === "ngo") {
        await API.post("/ngo/register", {
          name: formData.name,
          email: formData.email,
          password: formData.password,
          address: formData.address,
          phone: formData.phone
        });
        navigate("/ngo/login");
      }

      else if (formData.userType === "hotel") {
        await API.post("/hotel/register", {
          hotelName: formData.name,
          email: formData.email,
          password: formData.password,
          address: formData.address,
          phone: formData.phone
        });
        navigate("/hotel/login");
      }

      else {
        setMessage("Please select user type");
      }

    } catch (error) {
      setMessage("Registration failed. Try again.");
    }
  };

  return (
    <div className="register-page"
        
  style={{
    backgroundImage: "url('/images/food-waste.webp')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

      
     

    <div className="register-overlay"></div>

    <div className="register-card">
      <h1 className="brand">SaveBite</h1>
      <p className="tagline">Because every plate counts 🍽️</p>

      <form onSubmit={handleSubmit}>
        <select
          name="userType"
          value={formData.userType}
          onChange={handleChange}
          required
        >
          <option value="">Register as</option>
          <option value="hotel">Hotel</option>
          <option value="ngo">NGO</option>
        </select>

        <input name="name" placeholder="Name" onChange={handleChange} required />
        <input name="email" placeholder="Email" onChange={handleChange} required />
        <input name="phone" placeholder="Phone" onChange={handleChange} required />
        <input name="address" placeholder="Address" onChange={handleChange} required />
        <input type="password" name="password" placeholder="Password" onChange={handleChange} required />
        <input type="password" name="confirmPassword" placeholder="Confirm Password" onChange={handleChange} required />

        <button type="submit">Create Account</button>
      </form>

      {message && <p className="message">{message}</p>}
    </div>
  </div>
);
}
export default RegisterForm;
